module.exports = __webpack_public_path__ + "static/media/log-out-of-trial.af3726e9.png";